import { render, staticRenderFns } from "./transferWeditor.vue?vue&type=template&id=c3f0e1ea&scoped=true&"
import script from "./transferWeditor.vue?vue&type=script&lang=js&"
export * from "./transferWeditor.vue?vue&type=script&lang=js&"
import style0 from "./transferWeditor.vue?vue&type=style&index=0&id=c3f0e1ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f0e1ea",
  null
  
)

export default component.exports